import { Text, TTextLocalized } from '@northladder/i18n';

import { CircularProgressLoader } from '../loaders';

interface IContentLoadingViewProps {
  subTitle: TTextLocalized;
  title: TTextLocalized;
}

/**
 * -----------------------------------------------------------------------------
 * This is rendered while the app is retrieving the images list from the provided
 * sessionId in the url on first launch or refresh.
 */
export function ContentLoadingView({
  subTitle,
  title,
}: IContentLoadingViewProps) {
  return (
    <div className="flex min-h-[calc(100vh-15rem)] flex-col justify-center">
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="shadow-xs bg-white px-4 py-8 dark:bg-gray-900/50 sm:rounded-3xl sm:px-10">
          <div className="mx-auto px-4 text-center sm:px-6 lg:px-8">
            <div className="mx-auto flex max-w-4xl flex-col items-center py-8">
              <CircularProgressLoader className="size-12 mb-8" />
              <h1
                className="
                  text-primary-700 dark:text-primary-200 mt-4 text-xl font-normal
                  tracking-tight sm:text-xl
                "
              >
                <Text text={title} />
              </h1>
              <p className="text-primary-900 my-8 max-w-xl font-light dark:text-gray-200">
                <Text text={subTitle} />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
